module.exports = __webpack_public_path__ + "files/d07def5d253a0f9734c0a4795b3efbd2.svg";